export default "__VITE_ASSET__BUolqyQ2__"